import './styles.scss';

const Button = {
    Medium: ({ text, onClick, rightIcon, leftIcon, className = '' }) => {
        return (
            <button className={`button-medium ${className}`} onClick={onClick}>
                {leftIcon && <div className="side-icon left">{leftIcon}</div>}
                <span>{text}</span>
                {rightIcon && <div className="side-icon right">{rightIcon}</div>}
            </button>
        )
    },

    Large: ({ text, onClick, rightIcon, leftIcon, className = '' }) => {
        return (
            <button className={`button-large ${className}`} onClick={onClick}>
                {leftIcon && <div className="side-icon left">{leftIcon}</div>}
                <span>{text}</span>
                {rightIcon && <div className="side-icon right">{rightIcon}</div>}
            </button>
        )
    }
}

export default Button;